<!-- @format -->

<template>
    <header class="gst-header">
        <div>
            <TheLogo />
        </div>
        <div
            v-if="!$vuetify.breakpoint.mdAndUp"
            d-flex
            align-center
            shrink
            justify-center
            class="pl-2">
            <v-btn
                icon
                @click="openMenu">
                <BurgerIcon class="gst-burger-icon" />
            </v-btn>
        </div>
        <div
            v-else
            class="gst-header__links-wrapper d-flex ml-auto">
            <router-link
                class="d-flex"
                :to="routeEventsTab">
                <BaseIcon
                    symbol-id="icons--search"
                    class="mr-2" />
                {{ $t('linkSearch') }}
            </router-link>
            <router-link :to="goToHashOnCurrentRoute('#latest-deals')">
                {{ $t('linkLatestDeals') }}
            </router-link>
            <router-link :to="goToHashOnCurrentRoute('#faq')">
                {{ $t('linkFaq') }}
            </router-link>
            <LanguageSelectField class="ml-6" />
        </div>
    </header>
</template>

<script>
import SearchConstants from '@tenant/app/utils/constants/search';
import BurgerIcon from '@tenant/app/assets/icons/burger.svg';
import TheLogo from '@tenant/app/layouts/components/TheLogo.vue';
import LanguageSelectField from '@tenant/app/components/inputs/LanguageSelectField.vue';

export default {
    name: 'TheHeader',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'views.home.theHeader',
    },
    components: {
        TheLogo,
        LanguageSelectField,
        BurgerIcon,
    },
    data() {
        return {
            menuExpanded: false,
        };
    },
    computed: {
        routeEventsTab() {
            return this.goToHashOnCurrentRoute('#search-products', SearchConstants.TYPES.EVENTS);
        },
    },
    methods: {
        openMenu() {
            this.$emit('menu-opened');
        },
        goToHashOnCurrentRoute(hash) {
            return this.$router.resolve({
                name: this.$route.name,
                params: { destination: this.$route.params.destination },
                query: { ...this.$route.query },
                hash: hash,
            }).href;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

.gst-burger-icon {
    color: theme-color('white');
}
</style>
